import fiveStar from './five_star';
import freeFormText from './free_form_text';
import multipleChoice from './multiple_choice';
import yesNo from './yes_no';

export default {
  'FIVE_STAR': fiveStar,
  'FREE_FORM_TEXT': freeFormText,
  'MULTIPLE_CHOICE': multipleChoice,
  'YES_NO': yesNo,
};
